import React from "react";

const ProgramCodeBlock = ({ config }) => {
    const {
        code = "",
        language = "text",
        editable = false,
        showCompiler = false,
        showCopyButton = false,
    } = config || {};

    const handleCopy = async () => {
        try {
            await navigator.clipboard.writeText(code);
        } catch (error) {
            console.error("Failed to copy code:", error);
        }
    };

    return (
        <div className="w-full overflow-hidden rounded-xl border border-gray-200 bg-gray-950">

            {/* Header */}
            <div className="flex items-center justify-between border-b border-gray-800 px-4 py-2">

                <span className="text-xs text-gray-400 font-mono">
                    {language}
                </span>

                <div className="flex items-center gap-3">

                    {editable && (
                        <span className="text-xs text-gray-400">
                            قابل ویرایش
                        </span>
                    )}

                    {showCopyButton && (
                        <button
                            type="button"
                            onClick={handleCopy}
                            className="text-xs text-gray-400 transition hover:text-white"
                        >
                            کپی
                        </button>
                    )}

                </div>
            </div>

            {/* Code */}
            <pre
                dir="ltr"
                className="
                    overflow-x-auto
                    p-4
                    text-sm
                    leading-6
                    text-gray-100
                    font-mono
                    text-left
                "
            >
                <code>{code}</code>
            </pre>

            {/* Compiler */}
            {showCompiler && (
                <div className="border-t border-gray-800 px-4 py-3">
                    {/* Compiler UI goes here */}
                </div>
            )}

        </div>
    );
};

export default ProgramCodeBlock;
